import mutations from "@/store/mutations/vipMutation";
import getters from "@/store/getters/vipGetter";
/**
 *  mask
 */

export default {
  state: {
    zodiac_match: {
      free_count: 0,
      free_use_count: 0
    },
    cardClickTimes: 0,
    vipRouterData: null
  },
  mutations: mutations,
  getters: getters
};